import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  resource: 'document',
  operation: 'get',
  indexId: '',
  documentId: '',
  dataToSend: 'defineBelow',
  fieldsUi: { values: [] },
  simple: true,
  returnAll: false,
  limit: 10,
  options: {
    sourceFields: '',
    query: '{}',
    sort: '',
  },
  additionalFields: {
    numberOfShards: 1,
    numberOfReplicas: 1,
  },
  continueOnFail: false,
  // New operation defaults
  sourceArray: '',
  idField: '',
};

export default defaults;
